!(function () {
    "use strict";
    var t,
        e = {
            4559: function (t, e, n) {
                n.d(e, {
                    Dz: function () {
                        return o;
                    },
                    My: function () {
                        return s;
                    },
                    jW: function () {
                        return r;
                    },
                });
                const o = function () {
                        return {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json",
                                Accept: `application/${arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "json"}`,
                            },
                        };
                    },
                    r = function () {
                        let t = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
                        const e = window.innerWidth - document.body.offsetWidth,
                            n = document.getElementById("nav-wrapper");
                        t
                            ? (document.body.classList.add("no-scroll"),
                              (document.body.style.paddingRight = e + "px"),
                              (n.style.paddingRight = e + "px"))
                            : (document.body.classList.remove("no-scroll"),
                              (document.body.style.paddingRight = "0px"),
                              (n.style.paddingRight = "0px"));
                    };
                let a = () => {};
                const c = (t) => {
                        "Escape" === t.key && (a(), window.removeEventListener("keydown", c));
                    },
                    s = function () {
                        let t = arguments.length > 0 && void 0 !== arguments[0] && arguments[0],
                            e = arguments.length > 1 ? arguments[1] : void 0;
                        e && (a = e),
                            t && window.addEventListener("keydown", c),
                            t || window.removeEventListener("keydown", c);
                    };
                document.querySelectorAll(".local-scroll").forEach((t) => {
                    t.addEventListener("click", (t) => {
                        t.preventDefault(), t.stopPropagation();
                        const e = t.target.getAttribute("href");
                        ((t) => {
                            Math.easeInOutQuad = function (t, e, n, o) {
                                return (t /= o / 2) < 1 ? (n / 2) * t * t + e : (-n / 2) * (--t * (t - 2) - 1) + e;
                            };
                            const e = document.getElementById("grid-archive-header"),
                                n = document.getElementById("nav-wrapper");
                            let o = 0,
                                r = 0;
                            e && (o = e.offsetHeight + 50), n && (r = n.offsetHeight + 50);
                            const a = t.offsetTop - o - r,
                                c = window.scrollY,
                                s = a - c;
                            let i = 0;
                            const d = () => {
                                i += 5;
                                const t = Math.easeInOutQuad(i, c, s, 200);
                                window.scrollTo(0, t), i < 200 && setTimeout(d, 5);
                            };
                            d();
                        })(document.querySelector(e));
                    });
                });
            },
        },
        n = {};
    function o(t) {
        var r = n[t];
        if (void 0 !== r) return r.exports;
        var a = (n[t] = { exports: {} });
        return e[t](a, a.exports, o), a.exports;
    }
    (o.d = function (t, e) {
        for (var n in e) o.o(e, n) && !o.o(t, n) && Object.defineProperty(t, n, { enumerable: !0, get: e[n] });
    }),
        (o.o = function (t, e) {
            return Object.prototype.hasOwnProperty.call(t, e);
        }),
        (t = o(4559)),
        (() => {
            const e = document.querySelectorAll('form[action="/cart/add"]'),
                n = document.getElementById("main-cart"),
                o = document.getElementById("overlay"),
                r = document.getElementById("mini-cart"),
                a = document.querySelector("cart-service"),
                c = document.querySelector("body"),
                s = () => {
                    r.classList.remove("open"),
                        o.classList.remove("open"),
                        c.style.removeProperty("overflow"),
                        (0, t.jW)(!1);
                };
            e.length &&
                e.forEach((e) =>
                    e.addEventListener("submit", (c) => {
                        c.preventDefault(),
                            c.stopImmediatePropagation(),
                            c.target.querySelector('button[type="submit"] > span:not(.cart-icon):not(:empty)') &&
                                (c.target.querySelector(
                                    'button[type="submit"] > span:not(.cart-icon):not(:empty)'
                                ).textContent = `${cartStrings.addingToCart}`),
                            c.target.querySelector('button[type="submit"]').classList.add("added"),
                            (c.target.querySelector('button[type="submit"] > span.cart-icon').style.display = "none"),
                            (c.target.querySelector('button[type="submit"] > svg.loading-icon').style.display =
                                "block");
                        const i = (0, t.Dz)("javascript");
                        (i.headers["X-Requested-With"] = "XMLHttpRequest"), delete i.headers["Content-Type"];
                        const d = new FormData(e);
                        d.append("sections", "main-cart"),
                            (i.body = d),
                            fetch(`${routes.cartAdd}`, i)
                                .then((t) => t.json())
                                .then(async (e) => {
                                    if (e.status) {
                                        if (
                                            ((c.target.querySelector(
                                                'button[type="submit"] > span.cart-icon'
                                            ).style.display = "inline-flex"),
                                            (c.target.querySelector(
                                                'button[type="submit"] > svg.loading-icon'
                                            ).style.display = "none"),
                                            c.target.querySelector(
                                                'button[type="submit"] > span:not(.cart-icon):not(:empty)'
                                            ) &&
                                                (c.target.querySelector(
                                                    'button[type="submit"] > span:not(.cart-icon):not(:empty)'
                                                ).textContent = `${cartStrings.addToCart}`),
                                            "object" == typeof e.description)
                                        )
                                            return Object.entries(e.description).forEach((t) => {
                                                let [e, n] = t;
                                                const o = `${n.join(", ")}`;
                                                c.target.querySelector(".product-converter__error").innerHTML =
                                                    '<span class="icon loaded">error</span><p>' + o + "</p>";
                                            });
                                        c.target.querySelector(".product-converter__error").innerHTML =
                                            '<span class="icon loaded">error</span><p>' + e.description + "</p>";
                                    } else {
                                        if ("cart" === cartStrings.uxCart)
                                            return void (window.location.href = window.routes.cart);
                                        (c.target.querySelector(".product-converter__error").innerHTML = ""),
                                            n && n.classList.add("added"),
                                            a.renderItems(
                                                new DOMParser().parseFromString(e.sections["main-cart"], "text/html")
                                            ),
                                            "mini-cart" === cartStrings.uxCart &&
                                                (r && r.classList.add("open"),
                                                o &&
                                                    (o.classList.add("open", "overlay--all"),
                                                    (0, t.jW)(!0),
                                                    (0, t.My)(!0, s))),
                                            c.target.querySelector(
                                                'button[type="submit"] > span:not(.cart-icon):not(:empty)'
                                            ) &&
                                                (c.target.querySelector(
                                                    'button[type="submit"] > span:not(.cart-icon):not(:empty)'
                                                ).textContent = `${cartStrings.addedToCart}`),
                                            c.target.querySelector('button[type="submit"]').classList.remove("added"),
                                            c.target.querySelector('button[type="submit"]').classList.add("successful"),
                                            (c.target.querySelector(
                                                'button[type="submit"] > span.cart-icon'
                                            ).style.display = "flex"),
                                            (c.target.querySelector(
                                                'button[type="submit"] > svg.loading-icon'
                                            ).style.display = "none");
                                    }
                                })
                                .catch((t) => {
                                    console.error("Error:", t);
                                });
                    })
                );
        })();
})();
